import { useState } from "react";

const areas = [
  {
    highlight: true,
    icon: "ri-bank-line",
    tag: "Especialidade Principal",
    title: "Direito Bancário",
    subtitle: "Revisão de Juros Abusivos",
    description:
      "Nossa especialidade. Atuamos na análise e revisão de contratos bancários para identificar e combater juros abusivos, spread excessivo, capitalização irregular de juros e demais práticas ilegais das instituições financeiras.",
    items: [
      "Revisão de contratos de crédito pessoal",
      "Financiamentos e leasing",
      "Cartão de crédito e cheque especial",
      "Redução de dívida bancária",
      "Recuperação de valores pagos indevidamente",
    ],
  },
  {
    highlight: false,
    icon: "ri-scales-line",
    tag: "Área de Atuação",
    title: "Direito Penal",
    subtitle: "Defesa Criminal Especializada",
    description:
      "Defesa técnica e estratégica em processos criminais, garantindo que seus direitos constitucionais sejam plenamente respeitados em todas as fases do processo penal.",
    items: [
      "Crimes comuns e dolosos",
      "Habeas corpus",
      "Defesa em inquéritos policiais",
      "Recursos criminais",
      "Execução penal",
    ],
  },
  {
    highlight: false,
    icon: "ri-government-line",
    tag: "Área de Atuação",
    title: "Demais Áreas",
    subtitle: "Advocacia Geral",
    description:
      "Atendimento jurídico completo nas demais áreas do direito, sempre com o mesmo compromisso de excelência, estratégia personalizada e foco no melhor resultado para o cliente.",
    items: [
      "Direito civil e contratos",
      "Questões patrimoniais",
      "Consultoria jurídica preventiva",
      "Mediação e negociação",
      "Outras demandas jurídicas",
    ],
  },
];

export default function AreasAtuacao() {
  const [activeIdx, setActiveIdx] = useState(0);

  return (
    <section id="areas" className="py-24 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
            Onde atuamos
          </span>
          <h2 className="font-serif text-[#1A1A1A] text-3xl lg:text-4xl font-bold mt-3 mb-5">
            Áreas de Atuação
          </h2>
          <p className="text-[#2C2C2C]/70 text-base leading-relaxed font-sans">
            Advocacia especializada com foco em resultados reais. Cada caso tratado com estratégia e atenção personalizada.
          </p>
        </div>

        {/* ── MOBILE: Carousel ── */}
        <div className="lg:hidden">
          <div className="relative">
            {/* Card */}
            <div
              className={`rounded-lg overflow-hidden transition-all duration-300 ${
                areas[activeIdx].highlight
                  ? "bg-[#1A1A1A] ring-2 ring-[#B32025] shadow-lg"
                  : "bg-white border border-[#E6E6E6]"
              }`}
            >
              {areas[activeIdx].highlight && (
                <div className="bg-[#B32025] px-4 py-2 text-center">
                  <span className="text-white text-xs font-bold uppercase tracking-widest font-sans">
                    ⭐ Especialidade Principal
                  </span>
                </div>
              )}
              <div className="p-7">
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 ${
                    areas[activeIdx].highlight ? "bg-[#B32025]/20" : "bg-[#B32025]/8"
                  }`}
                >
                  <i className={`${areas[activeIdx].icon} text-2xl text-[#B32025] leading-none`} />
                </div>
                {!areas[activeIdx].highlight && (
                  <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
                    {areas[activeIdx].tag}
                  </span>
                )}
                <h3 className={`font-serif text-2xl font-bold mt-2 mb-1 ${areas[activeIdx].highlight ? "text-white" : "text-[#1A1A1A]"}`}>
                  {areas[activeIdx].title}
                </h3>
                <p className="text-sm font-medium mb-4 font-sans text-[#B32025]">{areas[activeIdx].subtitle}</p>
                <p className={`text-sm leading-relaxed mb-5 font-sans ${areas[activeIdx].highlight ? "text-[#BFBFBF]" : "text-[#2C2C2C]/70"}`}>
                  {areas[activeIdx].description}
                </p>
                <ul className="space-y-2">
                  {areas[activeIdx].items.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#B32025] leading-none" />
                      </div>
                      <span className={`text-sm font-sans ${areas[activeIdx].highlight ? "text-[#E6E6E6]" : "text-[#2C2C2C]/80"}`}>
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Prev / Next arrows */}
            <button
              onClick={() => setActiveIdx((i) => Math.max(0, i - 1))}
              disabled={activeIdx === 0}
              className="absolute top-1/2 -left-3 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white border border-[#E6E6E6] rounded-full shadow-sm disabled:opacity-30 cursor-pointer transition-opacity"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line text-lg text-[#1A1A1A] leading-none" />
            </button>
            <button
              onClick={() => setActiveIdx((i) => Math.min(areas.length - 1, i + 1))}
              disabled={activeIdx === areas.length - 1}
              className="absolute top-1/2 -right-3 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white border border-[#E6E6E6] rounded-full shadow-sm disabled:opacity-30 cursor-pointer transition-opacity"
              aria-label="Próximo"
            >
              <i className="ri-arrow-right-s-line text-lg text-[#1A1A1A] leading-none" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-6">
            {areas.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActiveIdx(idx)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${
                  idx === activeIdx ? "w-6 h-2 bg-[#B32025]" : "w-2 h-2 bg-[#BFBFBF]"
                }`}
                aria-label={`Card ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        {/* ── DESKTOP: Grid ── */}
        <div className="hidden lg:grid grid-cols-3 gap-8">
          {areas.map((area) => (
            <div
              key={area.title}
              className={`group relative rounded-lg overflow-hidden transition-all duration-300 cursor-default ${
                area.highlight
                  ? "bg-[#1A1A1A] ring-2 ring-[#B32025] shadow-lg"
                  : "bg-white border border-[#E6E6E6] hover:border-[#B32025]/30"
              }`}
            >
              {area.highlight && (
                <div className="bg-[#B32025] px-4 py-2 text-center">
                  <span className="text-white text-xs font-bold uppercase tracking-widest font-sans">
                    ⭐ Especialidade Principal
                  </span>
                </div>
              )}
              <div className="p-8">
                <div className={`w-14 h-14 flex items-center justify-center rounded-lg mb-6 transition-colors ${area.highlight ? "bg-[#B32025]/20" : "bg-[#B32025]/8 group-hover:bg-[#B32025]/15"}`}>
                  <i className={`${area.icon} text-2xl text-[#B32025] leading-none`} />
                </div>
                {!area.highlight && (
                  <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">{area.tag}</span>
                )}
                <h3 className={`font-serif text-2xl font-bold mt-2 mb-1 ${area.highlight ? "text-white" : "text-[#1A1A1A]"}`}>
                  {area.title}
                </h3>
                <p className="text-sm font-medium mb-4 font-sans text-[#B32025]">{area.subtitle}</p>
                <p className={`text-sm leading-relaxed mb-6 font-sans ${area.highlight ? "text-[#BFBFBF]" : "text-[#2C2C2C]/70"}`}>
                  {area.description}
                </p>
                <ul className="space-y-2">
                  {area.items.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-check-line text-sm text-[#B32025] leading-none" />
                      </div>
                      <span className={`text-sm font-sans ${area.highlight ? "text-[#E6E6E6]" : "text-[#2C2C2C]/80"}`}>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
